module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box",
    class: {
      'title-fixed': _vm.noVip
    }
  }, [_c('div', {
    staticClass: "titles clearfix",
    class: {
      'newV-titles': _vm.noVip
    }
  }, [_c('span', {
    staticClass: "fl tit-logo",
    class: {
      'newV-tit-logo': _vm.noVip
    }
  }), _vm._v(" "), (_vm.noVip) ? _c('span', {
    staticClass: "newV-tit-text"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr clearfix tit-userMes"
  }, [(_vm.vipState === 'loginNo') ? _c('a', {
    staticClass: "tit-icon-login fl",
    on: {
      "click": function($event) {
        return _vm.toLogin('https://cvip.58.com/view/pc', 'pc-cvip-topbar-dl')
      }
    }
  }, [_vm._v("登录")]) : _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "tit-icon fl"
  }, [(_vm.vipState === 1 || _vm.vipState === 10) ? _c('span', {
    staticClass: "tit-vip"
  }) : _vm._e(), _vm._v(" "), (_vm.userInfo.profile) ? _c('img', {
    attrs: {
      "src": '//pic1.58cdn.com.cn' + _vm.userInfo.profile
    }
  }) : _c('img', {
    attrs: {
      "src": "//img.58cdn.com.cn/ui6/my/images/touxiang_default.gif"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tit-name fl",
    class: {
      'newV-tit-my': _vm.noVip
    }
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))])]), _vm._v(" "), _c('a', {
    staticClass: "tit-my fl",
    class: {
      'newV-tit-my': _vm.noVip
    },
    on: {
      "click": function($event) {
        return _vm.toLogin('https://my.58.com/pro/myjob/index', 'pc-cvip-topbar-wdqz')
      }
    }
  }, [_vm._v("我的求职")]), _vm._v(" "), _c('a', {
    staticClass: "tit-my fl",
    class: {
      'newV-tit-my': _vm.noVip
    },
    on: {
      "click": function($event) {
        return _vm.toLogin('https://my.58.com/index', 'pc-cvip-topbar-grzx')
      }
    }
  }, [_vm._v("个人中心")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f5d7496"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/title/Title.vue
// module id = pPzb
// module chunks = 1